import { memo } from 'react'
import { isEqual } from 'lodash'
import { PageTitle } from 'app/components/common/PageTitle'
import R from 'app/assets/R'
import { useTranslation } from 'react-i18next'
import MaterialImportContainer from 'app/containers/InventoryManagement/OldInventory/MaterialImport'

const MaterialImportContainerPageCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.inventory_management)}</PageTitle>
      <MaterialImportContainer />
    </>
  )
}
const MaterialImportContainerPage = memo(MaterialImportContainerPageCpn, isEqual)

export default MaterialImportContainerPage
